import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/all";
import { useRef } from "react";

interface ResultsCounterProps {
  displayedCount: number;
  totalCount: number;
  searchQuery: string;
}

export function ResultsCounter({
  displayedCount,
  totalCount,
  searchQuery,
}: Readonly<ResultsCounterProps>) {
  const containerRef = useRef(null);

  useGSAP(
    () => {
      gsap.registerPlugin(ScrollTrigger);
      gsap.fromTo(
        "#faqsCounter",
        { autoAlpha: 0 },
        {
          autoAlpha: 1,
          duration: 0.5,
          scrollTrigger: {
            trigger: "#faqsCounter",
            start: "top bottom-=50",
            toggleActions: "play none none reverse",
          },
        },
      );
    },
    { scope: containerRef },
  );

  if (totalCount === 0) return null;

  return (
    <div
      ref={containerRef}
      className="mt-4 text-center text-sm text-gray-500 transition-opacity duration-300 ease-in-out"
    >
      <span id="faqsCounter">
        Showing {displayedCount} of {totalCount} FAQs
        {searchQuery && ` for "${searchQuery}"`}
      </span>
    </div>
  );
}
